export const TELEPHONE = {
  number: '',
  description: '',
}
